module.exports = __webpack_public_path__ + "img/tayaya-portorico.7b02fa87.jpg";